import { PartnerApi } from '@/services/api.ts';
import ApiError from '@/errors/ApiError';
import ServerError from '@/errors/ServerError';
import { i18n } from '@/i18n';
import moment from 'moment';
import { refreshWhatfix } from '@/utils/utils';

export default {
  state: {
    lang: '',
    token: '',
    id: '',
    externalId: '',
    hasVariablePricing: false,
  },

  mutations: {
    loginSuccess(state: any, opts: any) {
      state.token = opts.token;
      state.id = opts.partnerId;
      state.hasVariablePricing = opts.hasVariablePricing;
    },

    setLang(state: any, lang: string) {
      state.lang = lang;
    },

    setExternalId(state: any, externalId: string) {
      state.externalId = externalId;
    },

    setHasVariablePricing(state: any, hasVariablePricing: boolean) {
      state.hasVariablePricing = hasVariablePricing;
    },
  },

  getters: {
    separator(state: any) {
      return ['en', 'de'].indexOf(state.lang) > -1 ? '.' : ',';
    },
  },

  actions: {
    login({commit}: any, opts: any) {
      commit('setExternalId', opts.externalId);
      commit('setHasVariablePricing', opts.hasVariablePricing);
      const payload = {partnerCredentials: opts};
      return new Promise((resolve, reject) => {
        PartnerApi.partnerLoginPartnerCollection(payload, (error: Error, data: any, response: Response) => {
          if (!error) {
            commit('loginSuccess', data);
            resolve();
          } else {
            if (typeof(response) !== 'undefined') {
              const errorMap: any = {
                400: '102',
                401: '103',
              };
              reject(new ApiError(errorMap[response.status] || '101'));
            } else {
              reject(new ServerError('101'));
            }
          }
        });
      });
    },

    changeLanguage({commit}: any, code: string) {
      commit('setLang', code);
      i18n.locale = code;
      moment.locale(code);
      refreshWhatfix(code);
    },
  },
};
